<template>
<div>
    <v-card>
        <v-card-title class="align-baseline">
            <v-flex xs12 md2>
                <v-select :items="['All', 'Active', 'Inactive']" label="View Options" v-model="viewOptions"></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 md4>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-flex>
        </v-card-title>
        <v-data-table :headers="headers" :items="teachers" :search="search" :rows-per-page-items="[25,50,100]">
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-xs-left">{{ props.item.first_name }}</td>
                    <td class="text-xs-left">{{ props.item.last_name }}</td>
                    <td class="text-xs-left">{{ props.item.email }}</td>
                    <td class="text-xs-center">
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon class="mx-0" @click="editTeacher(props.item)">
                                <v-icon color="teal">create</v-icon>
                            </v-btn>
                            <span>Edit Teacher Details</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon class="mx-0" @click="showClasses(props.item)">
                                <v-icon color="primary">library_books</v-icon>
                            </v-btn>
                            <span>View Teacher's Classes</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn slot="activator" icon class="mx-0" @click="initDelete(props.item)">
                                <v-icon color="error">delete_forever</v-icon>
                            </v-btn>
                            <span>Delete Teacher</span>
                        </v-tooltip>
                    </td>
                </tr>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
    </v-card>

    <v-dialog persistent v-model="editTeacherDialog" max-width="500px">
        <teacher-edit-form :active="editTeacherDialog" :teacherData="teacherData" @close="editTeacherDialog = false">
        </teacher-edit-form>
    </v-dialog>

    <v-dialog v-model="teacherCoursesDialog.active" max-width="1000px">
        <teacher-courses :active="teacherCoursesDialog.active" :teacher="teacherCoursesDialog.teacher" @close="teacherCoursesDialog.active = false">
        </teacher-courses>
    </v-dialog>

    <v-dialog persistent v-model="deleteTeacherConfirm" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" type="error">
                    Are you sure you want to delete {{ teacherData.first_name }} {{ teacherData.last_name }}?
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="deleteTeacherConfirm = false">No</v-btn>
                <v-btn small color="primary" @click="deleteTeacher">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="alert.active" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" :type="alert.type">{{ alert.message }}</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click="alert.active = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import EditForm from './EditForm'
import TeacherCourses from './TeacherCourses'

export default {
    components: {
        TeacherEditForm: EditForm,
        TeacherCourses
    },
    data() {
        return {
            viewOptions: 'Active',
            search: '',
            headers: [{
                    text: 'First name',
                    align: 'left',
                    value: 'first_name',
                    width: '20%'
                },
                {
                    text: 'Last name',
                    align: 'left',
                    value: 'last_name',
                    width: '20%'
                },
                {
                    text: 'Email',
                    align: 'left',
                    value: 'email',
                    width: '25%'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: '',
                    width: '35%'
                },
            ],
            editTeacherDialog: false,
            deleteTeacherConfirm: false,
            teacherData: {},
            teacherCoursesDialog: {
                active: false,
                teacher: {}
            },
            alert: {
                active: false,
                message: '',
                type: 'success'
            }
        }
    },
    computed: {
        teachers() {
            return this.$store.state.admin.teachers.filter(t => {
                switch (this.viewOptions) {
                    case 'Active':
                        return t.active === 1
                        break
                    case 'Inactive':
                        return t.active === 0
                        break
                    default:
                        return t
                }
            })
        },
    },
    methods: {
        editTeacher(teacher) {
            this.teacherData = Object.assign({}, teacher)
            this.editTeacherDialog = true
        },
        showClasses(teacher) {
            this.teacherCoursesDialog.teacher = teacher
            this.teacherCoursesDialog.active = true
        },
        initDelete(teacher) {
            this.deleteTeacherConfirm = true
            this.teacherData = Object.assign({}, teacher)
        },
        deleteTeacher() {
            this.deleteTeacherConfirm = false
            this.$store.dispatch('deleteTeacher', this.teacherData.id).then(() => {
                    this.alert.active = true
                    this.alert.message = `${this.teacherData.first_name} ${this.teacherData.last_name} has successfully been deleted`
                    this.alert.type = 'success'
                })
                .catch((e) => {
                    this.alert.active = true
                    this.alert.type = 'error'

                    if (e.response.status === 400) {
                        this.alert.message = `${this.teacherData.first_name} ${this.teacherData.last_name} is still tied to at least one course, remove them from the course(s) before deleting.`
                    } else {
                        this.alert.message = 'Whoops looks like something went wrong!!!(in DataTable.vue)'
                    }
                })
        }
    }
}
</script>
